/* ====================================================================
   PR Can Coolers — PDP behavior. Upload to theme /assets/.
   Generalized from pet-wedding-can-coolers.js so ONE file serves every
   can-cooler listing. Reads config (variants, colors, ink, rush tiers)
   from the [data-pwk-config] JSON blob the section renders.

   Changes vs the pet-wedding original:
   · Price-break TICKS — the slider now renders one tick per real tier,
     with a labelled subset (first, last, active + every Nth), rebuilt
     whenever the style ladder or active break changes.
   · aria-valuetext on the slider announces "N koozies at $X each".
   · SUCCESS EVENT — after a successful /cart/add.js the script fires a
     cancelable "pr:cart-added" event on document. If a listener (the
     add-on popup) claims it via preventDefault(), the /cart redirect is
     suppressed and the popup takes over; otherwise behavior is
     unchanged (toast → /cart). The event fires ONLY on success — a
     failed or invalid add never dispatches it.
   ==================================================================== */
(function(){
  if(window.__prccLoaded) return; window.__prccLoaded=1;

  function run(){
    var root=document.querySelector('.pwk[data-pwk-root]') || document.querySelector('.pwk');
    var cfgEl=document.querySelector('[data-pwk-config]');
    if(!root || !cfgEl) return;
    var CFG; try{ CFG=JSON.parse(cfgEl.textContent); }catch(e){ return; }

    var $  = function(s,c){ return (c||root).querySelector(s); };
    var $$ = function(s,c){ return Array.prototype.slice.call((c||root).querySelectorAll(s)); };
    var T  = function(k,v){ $$('[data-pwk="'+k+'"]').forEach(function(el){ el.textContent=v; }); };
    var SHOW=function(k,on){ $$('[data-pwk-show="'+k+'"]').forEach(function(el){ el.classList.toggle('pwk-hidden',!on); }); };
    var money=function(n){ return '$'+(Math.round(n*100)/100).toFixed(2); };

    var state={ size:'standard', material:'foam', ink:'standard',
      colorIx:(CFG.defaultColorIx!=null?CFG.defaultColorIx:0), inkColorIx:0, design:0,
      personalization:(CFG.defaultPersonalization||''), mockup:false,
      qty:(CFG.defaultQty||50), rush:'std', acc:0 };

    var CONTRAST_MIN=3.5;  // WCAG ratio below this = ink hard to read on koozie

    /* ---- derived data ---------------------------------------------- */
    function variantKey(){
      var f=state.ink==='full';
      if(state.size==='slim') return f?'SL_F':'SL_S';
      if(state.material==='neoprene') return f?'SN_F':'SN_S';
      return f?'SF_F':'SF_S';
    }
    function variantsForStyle(k){
      var vs=(CFG.variants||[]).filter(function(v){return v.style===k;})
        .sort(function(a,b){return a.tier-b.tier;});
      if(vs.length) return vs;
      var fb=CFG.fallback && CFG.fallback[k];   // preview before variants are created
      if(fb) return fb.map(function(r){return {id:null,style:k,tier:r[0],price:Math.round(r[1]/r[0]*100)};});
      return [];
    }
    function activeColorList(){
      if(state.size==='slim') return CFG.colors.slim;
      if(state.material==='neoprene') return CFG.colors.neo;
      return CFG.colors.std;
    }
    function lum(hex){
      var h=hex.replace('#','');
      var r=parseInt(h.slice(0,2),16),g=parseInt(h.slice(2,4),16),b=parseInt(h.slice(4,6),16);
      return 0.299*r+0.587*g+0.114*b;   // 0 (black) … 255 (white)
    }
    function textOn(hex){ return lum(hex)>150 ? '#2c2530' : '#fbf9f5'; }
    /* WCAG contrast — handles dark-on-dark (e.g. charcoal on black) correctly,
       which a plain luminance-difference check misses. */
    function _lin(c){ c=c/255; return c<=0.03928 ? c/12.92 : Math.pow((c+0.055)/1.055,2.4); }
    function relLum(hex){
      var h=hex.replace('#','');
      return 0.2126*_lin(parseInt(h.slice(0,2),16))+0.7152*_lin(parseInt(h.slice(2,4),16))+0.0722*_lin(parseInt(h.slice(4,6),16));
    }
    function contrastRatio(a,b){ var la=relLum(a),lb=relLum(b),hi=Math.max(la,lb),lo=Math.min(la,lb); return (hi+0.05)/(lo+0.05); }
    function showRest(){ return !!state.size && (state.size==='slim' || !!state.material) && !!state.ink; }

    /* ---- builders (rebuilt on set-change) --------------------------- */
    var _colorSetKey=null;
    function buildColors(){
      var key=(state.size==='slim')?'slim':(state.material==='neoprene'?'neo':'std');
      if(key===_colorSetKey) return; _colorSetKey=key;
      var box=$('[data-pwk-colors]'); if(!box) return; box.innerHTML='';
      activeColorList().forEach(function(c,i){
        var b=document.createElement('button');
        b.type='button'; b.className='pwk-sw'; b.style.background=c[1];
        b.setAttribute('aria-label',c[0]); b.title=c[0]; b.dataset.colorIx=i;
        b.addEventListener('click',function(){ state.colorIx=i; render(); });
        box.appendChild(b);
      });
    }
    function buildInk(){
      var box=$('[data-pwk-ink]'); if(!box || box.dataset.built) return; box.dataset.built='1';
      (CFG.ink||[]).forEach(function(c,i){
        var b=document.createElement('button');
        b.type='button'; b.className='pwk-sw pwk-sw--ink'; b.style.background=c[1];
        b.setAttribute('aria-label',c[0]); b.title=c[0]; b.dataset.inkIx=i;
        b.addEventListener('click',function(){ state.inkColorIx=i; render(); });
        box.appendChild(b);
      });
    }
    /* price-break ticks under the slider — one tick per tier of the ACTIVE style.
       Positions use the half-thumb inset (thumb is 24px) so the first/last tick
       sit exactly under the thumb centre at each end. Labels: always first, last
       and the active break; plus every Nth (N = ceil(count/6)) when it doesn't
       crowd the active or endpoint labels. Endpoints show qty + price; the rest
       show qty only (the readout above already shows the active price). */
    var _ticksKey=null;
    function buildTicks(vs,activeIx){
      var box=$('[data-pwk-ticks]'); if(!box) return;
      var n=vs.length;
      var key=variantKey()+':'+n+':'+activeIx;
      if(key===_ticksKey) return; _ticksKey=key;
      box.innerHTML='';
      if(n<2){ box.classList.add('pwk-hidden'); return; }
      box.classList.remove('pwk-hidden');
      var step=Math.ceil(n/6);
      var guard=Math.max(1,Math.floor(step/2));   // min index distance between labels
      for(var i=0;i<n;i++){
        var pos='calc(12px + '+(i/(n-1))+' * (100% - 24px))';
        var t=document.createElement('span');
        t.className='pwk-tick'+(i===activeIx?' is-active':'');
        t.style.left=pos;
        box.appendChild(t);
        var isEdge=(i===0)||(i===n-1);
        var labelled=isEdge||(i===activeIx)||(i%step===0);
        if(labelled && !isEdge && i!==activeIx){
          // modulo labels give way when they'd crowd the active break or the ends
          if(Math.abs(i-activeIx)<guard) labelled=false;
          if(i<guard || (n-1)-i<guard) labelled=false;
        }
        if(labelled){
          var l=document.createElement('span');
          l.className='pwk-tick-lbl'+(i===activeIx?' is-active':'');
          l.style.left=pos;
          l.textContent=isEdge ? (vs[i].tier+' · '+money(vs[i].price/100)) : String(vs[i].tier);
          box.appendChild(l);
        }
      }
    }
    function rushDefs(){
      var thirdParty=(state.size==='slim')||(state.material==='neoprene');
      return thirdParty ? CFG.rushThird : CFG.rushFoam;
    }
    /* fee = ONE FLAT dollar amount per order (tier column d[3]) — never scales with quantity */
    function rushFeeFor(d){ return Math.max(0, Math.round(Number(d[3])||0)); }
    /* Step 4 — the free Standard production option (rendered on its own, above rush) */
    function buildStandard(){
      var box=$('[data-pwk-standard]'); if(!box) return; box.innerHTML='';
      var defs=rushDefs();
      var stdDef=defs.filter(function(d){return d[0]==='std';})[0] || defs[0];
      var on=(state.rush==='std') || !defs.find(function(d){return d[0]===state.rush;});
      var b=document.createElement('button');
      b.type='button'; b.className='pwk-rush'+(on?' is-active':'');
      b.innerHTML='<span class="pwk-rush-main"><span class="pwk-rush-title">'+stdDef[1]+
        '</span><span class="pwk-rush-window">'+stdDef[2]+'</span></span>'+
        '<span class="pwk-rush-fee">Included</span>';
      b.addEventListener('click',function(){ state.rush='std'; render(); });
      box.appendChild(b);
    }
    /* paid rush upgrades only (std lives above) */
    function buildRush(){
      var box=$('[data-pwk-rush]'); if(!box) return; box.innerHTML='';
      var defs=rushDefs();
      var rushId=state.rush; if(!defs.find(function(d){return d[0]===rushId;})) rushId='std';
      defs.forEach(function(d){
        if(d[0]==='std') return;
        var fee=rushFeeFor(d);
        var on=d[0]===rushId;
        var b=document.createElement('button');
        b.type='button'; b.className='pwk-rush'+(on?' is-active':'');
        var feeTxt='+$'+fee+' flat';
        b.innerHTML='<span class="pwk-rush-main"><span class="pwk-rush-title">'+d[1]+
          '</span><span class="pwk-rush-window">'+d[2]+'</span></span>'+
          '<span class="pwk-rush-fee">'+feeTxt+'</span>';
        b.addEventListener('click',function(){ state.rush=d[0]; render(); });
        box.appendChild(b);
      });
    }

    /* ---- static button bindings (once) ------------------------------ */
    $$('[data-size]').forEach(function(b){ b.addEventListener('click',function(){
      var s=b.dataset.size;
      if(s==='slim') state.size='slim', state.material='foam', state.colorIx=0, state.rush='std';
      else state.size='standard', state.colorIx=0;
      render();
    });});
    $$('[data-material]').forEach(function(b){ b.addEventListener('click',function(){
      var m=b.dataset.material;
      if(m==='neoprene') state.material='neoprene', state.size='standard', state.colorIx=0, state.rush='std';
      else state.material='foam';
      render();
    });});
    $$('[data-ink]').forEach(function(b){ b.addEventListener('click',function(){
      state.ink=b.dataset.ink; render();
    });});
    $$('[data-design-index]').forEach(function(b){ b.addEventListener('click',function(){
      state.design=parseInt(b.dataset.designIndex,10);
      render();
    });});
    $$('[data-acc-index]').forEach(function(b){ b.addEventListener('click',function(){
      var i=parseInt(b.dataset.accIndex,10);
      state.acc=(state.acc===i?-1:i); render();
    });});

    var qtyIn=$('[data-pwk-qty]');
    if(qtyIn) qtyIn.addEventListener('input',function(){
      state.qty=qtyIn.value.replace(/[^0-9]/g,''); render();
    });
    /* leaving the box with a number under the style's minimum snaps it up to the minimum */
    if(qtyIn) qtyIn.addEventListener('change',function(){
      var n=parseInt(state.qty,10)||currentMinTier;
      if(n<currentMinTier){ state.qty=String(currentMinTier); render(); }
    });
    /* the slider steps through the price breaks — each stop is one quantity tier */
    var sliderIn=$('[data-pwk-slider]');
    if(sliderIn) sliderIn.addEventListener('input',function(){
      var t=currentTiers[parseInt(sliderIn.value,10)||0];
      if(t) state.qty=String(t.tier);
      render();
    });
    var inc=$('[data-pwk-inc]'); if(inc) inc.addEventListener('click',function(){
      state.qty=String(Math.max(parseInt(state.qty,10)||0,currentMinTier)+5); render(); });
    /* "–" never goes under the style's minimum (12 on Slim / Neoprene, 1 on Standard foam) */
    var dec=$('[data-pwk-dec]'); if(dec) dec.addEventListener('click',function(){
      state.qty=String(Math.max(currentMinTier,(parseInt(state.qty,10)||currentMinTier)-5)); render(); });

    var persIn=$('[data-pwk-pers]');
    if(persIn){ persIn.value=state.personalization;
      persIn.addEventListener('input',function(){ state.personalization=persIn.value; render(); }); }

    var mockIn=$('[data-pwk-mockup]');
    if(mockIn) mockIn.addEventListener('change',function(){ state.mockup=mockIn.checked; render(); });

    var fileIn=$('[data-pwk-file]'), fileName=$('[data-pwk-filename]');
    if(fileIn) fileIn.addEventListener('change',function(){
      if(fileIn.files && fileIn.files[0] && fileName) fileName.textContent='✓ '+fileIn.files[0].name;
    });

    $$('[data-pwk-switchfoam]').forEach(function(a){ a.addEventListener('click',function(e){
      if(e&&e.preventDefault)e.preventDefault();
      state.size='standard'; state.material='foam'; state.colorIx=0; state.rush='std'; render();
    });});

    /* ---- shared scratch values for handlers ------------------------ */
    var currentMinTier=1, currentTiers=[];

    /* ---- render ---------------------------------------------------- */
    function render(){
      var key=variantKey();
      var vs=variantsForStyle(key);
      if(!vs.length){ return; }
      var minTier=vs[0].tier; currentMinTier=minTier;
      /* MINIMUM ORDER — the lowest price break of the chosen style is the floor
         (Slim & Neoprene ladders start at 12, Standard foam at 1). Anything under
         it is priced, shown and submitted as the minimum; the typed box is left
         alone only while the shopper is still typing in it (snaps on blur). */
      var typed=parseInt(state.qty,10)||minTier;
      var belowMin=typed<minTier;
      var qn=belowMin?minTier:typed;
      if(belowMin && document.activeElement!==qtyIn){ state.qty=String(qn); belowMin=false; }
      var chosen=vs[0]; for(var i=0;i<vs.length;i++){ if(qn>=vs[i].tier) chosen=vs[i]; }
      var per=chosen.price/100;
      var total=qn*per;
      currentTiers=vs;
      var activeIx=vs.indexOf(chosen); if(activeIx<0) activeIx=0;

      /* quantity slider steps through the price breaks — one stop per tier */
      var sldr=$('[data-pwk-slider]');
      if(sldr){
        sldr.min=0; sldr.max=Math.max(0, vs.length-1); sldr.step=1;
        if(document.activeElement!==sldr){
          sldr.value=activeIx;
        }
        /* the raw value is a meaningless index — announce the real tier */
        sldr.setAttribute('aria-valuetext', chosen.tier+' koozies at '+money(per)+' each');
      }
      buildTicks(vs, activeIx);

      /* color set + clamp */
      buildColors();
      var colorList=activeColorList();
      var cix=Math.min(state.colorIx, colorList.length-1); if(cix<0) cix=0;
      var cur=colorList[cix];
      buildInk();
      var inkList=CFG.ink||[];
      var iix=Math.min(state.inkColorIx, inkList.length-1); if(iix<0) iix=0;

      /* gallery main image — always reflects the Step-1 design selection.
         Falls back to whatever the section rendered if the chosen design has no image. */
      var mainEl=$('[data-pwk-main]');
      var selDesign=$('[data-design-index="'+state.design+'"]');
      if(mainEl && selDesign && selDesign.dataset.full){
        mainEl.src=selDesign.dataset.full;
        mainEl.alt=(selDesign.dataset.designName||'')+' — custom can cooler';
      }

      /* active classes */
      $$('[data-size]').forEach(function(b){ b.classList.toggle('is-active', b.dataset.size===state.size); });
      $$('[data-material]').forEach(function(b){
        var m=b.dataset.material;
        var on=(m==='foam') ? (state.material==='foam'||state.size==='slim')
                            : (state.material==='neoprene'&&state.size!=='slim');
        b.classList.toggle('is-active', on);
      });
      $$('[data-ink]').forEach(function(b){ b.classList.toggle('is-active', b.dataset.ink===state.ink); });
      $$('[data-design-index]').forEach(function(b){
        b.classList.toggle('is-active', parseInt(b.dataset.designIndex,10)===state.design); });
      $$('[data-pwk-colors] .pwk-sw').forEach(function(b){
        b.classList.toggle('is-active', parseInt(b.dataset.colorIx,10)===cix); });
      $$('[data-pwk-ink] .pwk-sw').forEach(function(b){
        b.classList.toggle('is-active', parseInt(b.dataset.inkIx,10)===iix); });
      $$('[data-acc-index]').forEach(function(b){
        b.parentElement.classList.toggle('is-open', parseInt(b.dataset.accIndex,10)===state.acc); });

      /* progressive reveal */
      SHOW('material', state.size==='standard');
      SHOW('printing', !!state.size && (state.size==='slim' || !!state.material));
      SHOW('rest', showRest());
      SHOW('inkColor', state.ink==='standard');

      /* rush (standard shown above the paid upgrades) */
      buildStandard();
      buildRush();
      var defs=rushDefs();
      var rushId=state.rush; if(!defs.find(function(d){return d[0]===rushId;})) rushId='std';
      var rushSel=defs.find(function(d){return d[0]===rushId;});
      var rushFee=rushFeeFor(rushSel);
      var thirdParty=(state.size==='slim')||(state.material==='neoprene');
      var etaMap={'std':'~3–4 weeks','3-4w':'~3–4 weeks','2-3w':'~2–3 weeks','10-14':'~10–14 days','7-10':'~7–10 days','1w':'~1 week'};
      T('rushEta','Est. in hand: '+(etaMap[rushId]||'~3–4 weeks')+' after proof');
      SHOW('rushSwitch', thirdParty);
      SHOW('rushShip', rushSel[4]!=='');
      T('rushShipKind', rushSel[4]==='overnight'?'overnight':'expedited / 2-day');
      SHOW('rushOneWeek', !thirdParty && rushId==='1w');

      var grand=total+rushFee;

      /* labels */
      var variantLabel=(state.size==='slim'?'Slim':'Standard')+' · '+
        (state.material==='neoprene'&&state.size!=='slim'?'Neoprene':'Foam')+' · '+
        (state.ink==='full'?'Full color':'Std ink');
      var designBtn=$('[data-design-index="'+state.design+'"]');
      var designName=designBtn?(designBtn.dataset.designName||'Selected design'):'Selected design';

      T('unitPrice', money(per));
      T('unitLabel', money(per)+'/ea');
      T('totalLabel', money(total));
      T('qty', qn);
      T('variantLabel', variantLabel);
      T('colorName', cur[0]);
      T('colorCount', colorList.length);
      T('inkColorName', inkList[iix]?inkList[iix][0]:'');
      T('inkNameShown', state.ink==='standard' ? (inkList[iix]?inkList[iix][0]:'') : 'Full color');
      T('designName', designName);
      T('materialNote', state.size==='slim' ? 'Slim cans are foam only'
        : (state.material==='neoprene'?'Premium thicker foam':''));
      T('grandLabel', money(grand));
      T('rushLabel', money(rushFee));
      SHOW('hasRush', rushFee>0);

      /* minimum-order note under the Quantity box — only styles with a floor above 1 */
      T('minQty', minTier);
      T('minStyle', state.size==='slim'?'Slim cans':(state.material==='neoprene'?'Neoprene':'Standard'));
      SHOW('minNote', minTier>1);
      SHOW('minBumped', belowMin);
      $$('[data-pwk-minnote]').forEach(function(el){ el.classList.toggle('is-warn', belowMin); });

      if(qtyIn && document.activeElement!==qtyIn) qtyIn.value=state.qty;

      /* preview tile */
      var canEl=$('[data-pwk-preview-can]');
      if(canEl){
        var inkHex=state.ink==='standard' ? (inkList[iix]?inkList[iix][1]:textOn(cur[1])) : textOn(cur[1]);
        canEl.style.background=cur[1]; canEl.style.color=inkHex;
      }
      T('personalizationShown', state.personalization || 'Your names\nyour date');

      /* readability tip — flag ink + koozie colors that are too close in luminance */
      var tipEl=$('[data-pwk-contrast]');
      if(tipEl){
        var poor=(state.ink==='standard' && inkList[iix]) ? (contrastRatio(inkList[iix][1],cur[1])<CONTRAST_MIN) : false;
        tipEl.classList.toggle('pwk-hidden', !poor);
      }

      /* ATC enablement + stash for submit (needs a real, fully-chosen variant) */
      var ready=showRest() && !!chosen.id;
      $$('[data-pwk-atc]').forEach(function(b){ b.disabled=!ready; });
      submitData={ ready:ready, variantId:chosen.id, qty:qn, variantLabel:variantLabel,
        colorName:cur[0], inkName:inkList[iix]?inkList[iix][0]:'', designName:designName,
        koozieSubtotal:money(total), rushFee:rushFee, rushWindow:rushSel[2],
        eta:(etaMap[rushId]||'~3–4 weeks'), mockup:state.mockup, grand:money(grand) };
    }

    /* ---- add to cart ---------------------------------------------- */
    var submitData={};
    var form=$('[data-pwk-form]');
    function setHidden(name,val){ var el=$('[name="properties['+name+']"]',form); if(el) el.value=val; }

    function addToCart(){
      if(!submitData.ready || !form) return;
      var d=submitData;
      if(!(d.qty>=currentMinTier)) return;   // never send less than the style's minimum
      $('[name="id"]',form).value=d.variantId;
      $('[name="quantity"]',form).value=d.qty;
      setHidden('Can size', state.size==='slim'?'Slim':'Standard 12 oz');
      setHidden('Material', (state.material==='neoprene'&&state.size!=='slim')?'Neoprene':'Foam');
      setHidden('Printing', state.ink==='full'?'Full color':'Standard ink');
      setHidden('Ink color', state.ink==='standard'?d.inkName:'—');
      setHidden('Koozie color', d.colorName);
      setHidden('Design', d.designName);
      /* the chosen design's image, so the cart line can show the right picture */
      var designBtnEl=$('[data-design-index="'+state.design+'"]');
      setHidden('_design_image', (designBtnEl&&designBtnEl.dataset.full)||'');
      setHidden('Personalization', state.personalization);
      setHidden('Quantity', String(d.qty));
      setHidden('Koozie subtotal', d.koozieSubtotal);
      setHidden('Delivery speed', d.rushFee>0?('Rush · '+d.rushWindow):'Standard · 3–4 weeks');
      setHidden('Rush production fee', d.rushFee>0?('$'+d.rushFee):'$0');
      setHidden('Est. delivery window', d.eta);
      setHidden('Digital mockup', d.mockup?'Yes — email a mockup before production':'Not requested');

      var btns=$$('[data-pwk-atc]'); btns.forEach(function(b){b.disabled=true;});
      if(!window.fetch){ form.submit(); return; }
      var fd=new FormData(form);
      fetch('/cart/add.js',{method:'POST',body:fd,credentials:'same-origin'})
        .then(function(r){ if(!r.ok) throw new Error('cart'); return r.json(); })
        .then(function(){
          if(d.rushFee>0){
            var props={ 'For':d.designName+' can coolers', 'Delivery speed':d.rushWindow };
            /* FLAT FEE LINE — prefer a fee-product VARIANT priced exactly at the fee,
               so the cart shows ONE line: "Rush Production Fee · $185.00 · qty 1".
               (Give the rush-production-fee product one variant per tier fee:
               $40 / $60 / $75 / $120 / $185.) If no variant matches the fee, fall
               back to buying fee ÷ unit-price units of the base variant so the
               charged amount is still exactly right. */
            var feeCents=d.rushFee*100;
            var exact=(CFG.rushFeeVariants||[]).filter(function(v){return v.price===feeCents && v.available!==false;})[0];
            var payload=null;
            if(exact){ payload={ id:exact.id, quantity:1, properties:props }; }
            else if(CFG.rushProductVariantId){
              var unitCents=CFG.rushProductUnitPrice||100;
              var rushQty=Math.round(feeCents/unitCents);
              if(rushQty>0) payload={ id:CFG.rushProductVariantId, quantity:rushQty, properties:props };
            }
            if(payload) return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
              credentials:'same-origin', body:JSON.stringify(payload)});
          }
        })
        .then(function(){
          toast();
          /* SUCCESS HANDOFF — announce the add. The add-on popup (if installed
             and configured for this product) claims the event via
             preventDefault() and opens; then we stay on the page. If nobody
             claims it, keep the original behavior: short pause → /cart.
             This only ever runs after BOTH cart adds resolved OK, so the
             popup can never open on a failed or incomplete add. */
          var claimed=false;
          try{
            var ev=new CustomEvent('pr:cart-added',{cancelable:true,detail:{
              source:'pr-cancooler', variantId:d.variantId, quantity:d.qty,
              designName:d.designName, colorName:d.colorName, grand:d.grand }});
            claimed=!document.dispatchEvent(ev);
          }catch(e){ claimed=false; }
          if(claimed){ btns.forEach(function(b){b.disabled=false;}); }
          else { setTimeout(function(){ window.location.href='/cart'; },650); }
        })
        .catch(function(){ btns.forEach(function(b){b.disabled=false;}); form.submit(); });
    }
    $$('[data-pwk-atc]').forEach(function(b){ b.addEventListener('click',function(e){ e.preventDefault(); addToCart(); }); });
    if(form) form.addEventListener('submit',function(e){ if(window.fetch){ e.preventDefault(); addToCart(); } });

    var _toastT;
    function toast(){
      var el=$('[data-pwk-toast]'); if(!el) return;
      var d=submitData;
      el.innerHTML='<b>✓</b> Added '+d.qty+' '+d.designName+' koozies in '+d.colorName+' — '+d.grand;
      el.classList.add('is-on');
      clearTimeout(_toastT); _toastT=setTimeout(function(){ el.classList.remove('is-on'); },3000);
    }

    /* ---- sticky bar visibility ------------------------------------ */
    var sticky=$('[data-pwk-sticky]'); var buybox=$('[data-pwk-buybox]');
    if(sticky && buybox){
      window.addEventListener('scroll',function(){
        var r=buybox.getBoundingClientRect();
        sticky.classList.toggle('is-visible', r.bottom<window.innerHeight*0.4 || r.top<-40);
      },{passive:true});
    }

    /* ---- deep link: ?design=<index>&dn=<handleized design name> ------
       Sent by the new-wedding-koozies collection page, where every grid card is
       one product image. `design` is the image index; `dn` is the handleized
       design name and wins whenever it matches, so a shared or bookmarked link
       still lands on the right design after images are reordered in Admin.
       Missing or out-of-range values leave the default (design 0) untouched. */
    (function applyDeepLink(){
      var qs; try{ qs=new URLSearchParams(window.location.search); }catch(e){ return; }
      var btns=$$('[data-design-index]');
      if(!btns.length) return;

      var slug=function(v){ return String(v==null?'':v).toLowerCase().trim()
        .replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,''); };

      var target=null, dn=qs.get('dn');
      if(dn){
        var want=slug(dn);
        for(var i=0;i<btns.length;i++){
          if(want && slug(btns[i].dataset.designName)===want){ target=i; break; }
        }
      }
      if(target===null){
        var ix=parseInt(qs.get('design'),10);
        if(!isNaN(ix) && ix>=0 && ix<btns.length) target=ix;
      }
      if(target!==null) state.design=target;
    })();

    render();
  }

  if(document.readyState!=='loading') run();
  else document.addEventListener('DOMContentLoaded', run);
})();
